import makeStorage from './storage';

// Utilitário para gerenciar o estabelecimento selecionado no localStorage
const establishmentStorage = makeStorage('establishment_selecionado', 'localStorage', {});

export interface EstablishmentStorageData {
  establishment_alias_id: number | string;
  establishment_id: number | string | null;
  description: string;
  cnpj?: string | null;
}

export const EstablishmentStorageUtils = {
  // Salva estabelecimento no localStorage
  save: (data: EstablishmentStorageData) => {
    establishmentStorage.save(data);
  },

  // Recupera estabelecimento do localStorage
  get: (): EstablishmentStorageData | null => {
    const data = establishmentStorage.get();
    return data && data.establishment_alias_id ? data : null;
  },

  // Remove estabelecimento do localStorage
  clear: () => {
    establishmentStorage.remove();
  }
};

export default EstablishmentStorageUtils; 